import $ from '../../../../../FrontendBundle/Resources/js/jquery';
import DropdownField from './dropdownField';
import SetItemAccessoryCommand from '../command/setItemAccessoryCommand';

/**
 * @class AccessoryField
 */
export default class AccessoryField extends DropdownField {
    type = 'accessory';
    supports = null;

    getDropdownTemplateString() {
        return `
            <li data-item="<%= itemId %>"<% if (active) { %> class="active"<% } %>>
                <div class="thumbnail">
                    <% if(accessoryImage === null) { %>
                        <img src="<%= image %>" width="50" height="50" />
                    <% } else { %>
                        <img src="<%= accessoryImage %>" width="50" height="50" />
                    <% } %>
                </div> 
                <% if(key !== "no_accessory") { %>
                    <p class="manufacturer"><%= manufacturer %></p>
                    <h3 class="title"><%= title %></h3>
                    <p class="product-number"><%= productNr %></p>
                <% } else { %>
                    <p class="empty">${this.translations.no_accessory_entry}</p>
                <% } %>
            </li>
        `;
    }

    /**
     * Register click event on dropdown.
     *
     * @param {jQuery} dropdown
     */
    registerEventsForDropdown(dropdown) {
        dropdown.on('click', 'li', async (e) => {
            const target = $(e.currentTarget);
            const itemId = target.data('item');
            const canvas = this.editor.getCanvas();
            const history = canvas.getHistory();
            const selection = canvas.getSelection();
            const item = selection.first();
            const itemFactory = canvas.getItemFactory();

            const newItem = await itemFactory.create(
                'figure',
                {
                    itemId,
                    x: item.get('position').x,
                    y: item.get('position').y,
                    rotation: item.get('rotation'),
                },
                item.getParentItem(),
            );
            const command = new SetItemAccessoryCommand(
                item.getParentItem().getItems(),
                selection,
                [{
                    oldItem: item,
                    newItem,
                }],
            );

            history.addAndExecuteCommand(command);
        });
    }

    /**
     * Update text with item value.
     *
     * @param {ItemInterface} item
     */
    updateText(item) {
        const productionDataStore = this.editor.getCanvas().getItemFactory().getProductionDataStore();
        const productFamily = productionDataStore.getProductFamilyForItem(item);
        const name = productFamily.getAccessoryProductNrFor(item.get('size'), item.get('accessory'), item.get('align'))
            ?? this.translations.no_accessory_button;

        this.button.children('.text').text(name);
    }

    /**
     * Update text with item value.
     *
     * @param {ItemInterface} item
     */
    updateOptions(item) {
        const productionDataStore = this.editor.getCanvas().getItemFactory().getProductionDataStore();
        const productFamily = productionDataStore.getProductFamilyForItem(item);
        const accessoryOptions = productFamily.getAccessoryOptions(item);

        this.setOptions(accessoryOptions);
    }

    /**
     * Update item with field value.
     */
    updateItem() {}

    /**
     * Do action.
     *
     * @param {ItemInterface} item
     * @param {Object} parameters
     */
    action(item, parameters) {
        if (!this.isHidden && parameters && parameters.showAccessory) {
            $('.dropdown-menu', this.control).dropdown('toggle');
        }
    }

    /**
     * Check if field is supportet by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        if (!(selectionLength === 1 && item && item.supportsAlign)) {
            return false;
        }

        try {
            const productionDataStore = this.editor.getCanvas().getItemFactory().getProductionDataStore();
            const productFamily = productionDataStore.getProductFamilyForItem(item);
            const accessoryOptionsCount = productFamily.getAccessoryCount(item);

            return accessoryOptionsCount > 1;
        } catch (e) {
            return false;
        }
    }
}
